import { EventHandler, ParsedEvent } from './types';

export class SSEEventProcessor {
  private handlerMap: Map<string, EventHandler['handler']>;

  constructor(handlers: EventHandler[]) {
    this.handlerMap = new Map(handlers.map((handler) => [handler.event, handler.handler]));
  }

  public async handleMessage(event: string): Promise<void> {
    try {
      const parsedEvent = JSON.parse(event) as ParsedEvent;
      if (!parsedEvent) return;

      const handler = this.handlerMap.get(parsedEvent.data.event);
      if (handler) {
        try {
          await handler(parsedEvent);
        } catch (error) {
          console.error(`Handler for event ${parsedEvent.data.event} threw an error:`, error);
        }
      }
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
  }
}
